var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('support-placeholder',{attrs:{"title":_vm.placeholder.title,"articles":_vm.placeholder.articles,"buttons":_vm.placeholder.buttons,"video":_vm.placeholder.video,"content":_vm.placeholder.content}})}
var staticRenderFns = []

export { render, staticRenderFns }